var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 83,
    height: 53,
    viewBox: "0 0 83 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.5474 26.1328C60.0062 26.1328 63.4312 25.4569 66.6268 24.1436C69.8224 22.8303 72.7259 20.9054 75.1717 18.4787C77.6175 16.052 79.5576 13.1712 80.8813 10.0006C82.2049 6.83002 82.8862 3.43181 82.8862 1.1423e-06L56.5474 0L56.5474 26.1328Z",
    fill: "#FEB449"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6543 52.0342C79.1954 52.0342 75.7704 51.3583 72.5749 50.045C69.3793 48.7317 66.4757 46.8067 64.0299 44.3801C61.5841 41.9534 59.644 39.0725 58.3204 35.902C56.9967 32.7314 56.3155 29.3332 56.3155 25.9014L82.6543 25.9014L82.6543 52.0342Z",
    fill: "#FEB449"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56.48 25.9697C53.0211 25.9697 49.5961 26.6457 46.4005 27.9589C43.205 29.2722 40.3014 31.1972 37.8556 33.6238C35.4098 36.0505 33.4697 38.9314 32.1461 42.1019C30.8224 45.2725 30.1412 48.6707 30.1412 52.1025L56.48 52.1025L56.48 25.9697Z",
    fill: "#FEB449"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2803 1.49292C40.808 1.49292 39.3502 1.78291 37.99 2.34632C36.6298 2.90974 35.394 3.73555 34.3529 4.7766C33.3119 5.81766 32.4861 7.05357 31.9227 8.41377C31.3593 9.77397 31.0693 11.2318 31.0693 12.7041L42.2803 12.7041L42.2803 1.49292Z",
    fill: "#2B42C4"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1812 23.8157C43.6534 23.8157 45.1112 23.5257 46.4714 22.9623C47.8316 22.3989 49.0675 21.573 50.1085 20.532C51.1495 19.4909 51.9753 18.255 52.5387 16.8948C53.1021 15.5346 53.3921 14.0768 53.3921 12.6045L42.1812 12.6045L42.1812 23.8157Z",
    fill: "#2B42C4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3921 12.7041C53.3921 11.2318 53.1021 9.77397 52.5387 8.41377C51.9753 7.05357 51.1495 5.81765 50.1085 4.7766C49.0675 3.73555 47.8316 2.90974 46.4714 2.34632C45.1112 1.78291 43.6534 1.49292 42.1812 1.49292V12.7041H53.3921Z",
    fill: "#2B42C4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0693 12.6045C31.0693 14.0768 31.3593 15.5346 31.9227 16.8948C32.4861 18.255 33.3119 19.4909 34.3529 20.532C35.394 21.573 36.6298 22.3989 37.99 22.9623C39.3502 23.5257 40.808 23.8157 42.2803 23.8157L42.2803 12.6045L31.0693 12.6045Z",
    fill: "#2B42C4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M13.355 52.9865V39.6416L26.4074 26.4834V39.6416L13.355 52.9865Z",
    fill: "#79C3AA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M0 52.9865V39.6416L13.356 26.4834V39.6416L0 52.9865Z",
    fill: "#79C3AA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c0ab40992008caf3f33864e323db17ee.svg";
export { ForwardRef as ReactComponent };